<script>
import {useTaskModelStore} from "@/stores/Boarding/TaskModel";
import {onMounted, ref} from "vue";
import axios from "axios";

export default {
    name: "StrTaskModelSelect",
    props: {
        dialog: Boolean,
        ids: {
            type: Array,
            default: () => {
                return [];
            },
        }
    },
    emits: ['add', 'remove', 'close'],
    setup(props, {emit}) {
        const loading = ref(false);
        const selected = ref([]);
        const taskStore = useTaskModelStore();

        function findAll() {
            loading.value = true;
            axios.get('/boardingTaskModels').then(response => {
                taskStore.setTaskModels(response.data);
            }).finally(() => {
                loading.value = false;
            })
        }

        function addTask(task) {
            if (props.ids.includes(task.id)) {
                emit('remove', task);
            } else {
                emit('add', task);
            }
        }

        function close() {
            emit('close');
        }

        /*watch(() => props.ids, () => {
          selected.value = props.ids;
        }, {immediate: true});*/

        onMounted(() => {
            findAll();
        });

        return {
            taskStore,
            loading,
            selected,
            addTask,
            close,
        }
    }
}
</script>

<template>
    <v-dialog
        v-model="dialog"
        max-width="600"
        scrollable
        persistent
    >
        <v-card>
            <w-toolbar color="blue darken-2" :title="$t('module.task_models')"/>
            <v-card-text>
                <v-list dense>
                    <template v-for="(task, index) in taskStore.taskModels">
                        <v-list-item
                            :key="`item-${index}`"
                            @click="addTask(task)"
                        >
                            <v-list-item-title>
                                {{ task.name }}
                            </v-list-item-title>
                            <v-list-item-action>
                                <v-icon v-if="ids.includes(task.id)" color="teal">mdi-checkbox-multiple-marked-circle</v-icon>
                            </v-list-item-action>
                        </v-list-item>
                        <v-divider :key="`divider-${index}`"/>
                    </template>
                </v-list>
            </v-card-text>
            <v-divider/>
            <v-card-actions>
                <v-spacer/>
                <w-btn-close @press="close"/>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>